import React from 'react';
import { Container, Grid, Card, CardContent, Typography, Button, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import DescriptionIcon from '@mui/icons-material/Description';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[8],
    },
  },
  cardContent: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: theme.spacing(4),
  },
  icon: {
    fontSize: 64,
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  cardTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  cardDescription: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  button: {
    marginTop: 'auto',
  },
}));

/**
 * Overview page for Manual Ingest - allows users to choose between UB04 and CMS-1500 forms
 */
export const ManualIngestOverviewPage: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleNavigateToUB04 = () => {
    history.push('/manual-ingest/ub04');
  };

  const handleNavigateToCMS1500 = () => {
    history.push('/manual-ingest/cms1500');
  };

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Typography variant="h3" component="h1" className={classes.title}>
        Manual Ingest
      </Typography>
      
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} md={6}>
          <Card className={classes.card} onClick={handleNavigateToUB04}>
            <CardContent className={classes.cardContent}>
              <CloudUploadOutlinedIcon className={classes.icon} />
              <Typography variant="h4" component="h2" className={classes.cardTitle}>
                UB04 Forms
              </Typography>
              <Typography variant="body1" className={classes.cardDescription}>
                Process and manage UB04 institutional claim forms. Handle hospital and facility billing with comprehensive form management.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                size="large"
                className={classes.button}
                onClick={handleNavigateToUB04}
              >
                Manage UB04 Forms
              </Button>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Card className={classes.card} onClick={handleNavigateToCMS1500}>
            <CardContent className={classes.cardContent}>
              <DescriptionIcon className={classes.icon} />
              <Typography variant="h4" component="h2" className={classes.cardTitle}>
                CMS-1500 Forms
              </Typography>
              <Typography variant="body1" className={classes.cardDescription}>
                Process and manage CMS-1500 professional claim forms. Handle physician and professional service billing efficiently.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                size="large"
                className={classes.button}
                onClick={handleNavigateToCMS1500}
              >
                Manage CMS-1500 Forms
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};
